import { render } from "./MediaLinksSummaryPage.vue?vue&type=template&id=35112d0a"
import script from "./MediaLinksSummaryPage.vue?vue&type=script&lang=js"
export * from "./MediaLinksSummaryPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__